import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * Extract a user-facing error message from an axios error.
 * Backend returns { detail: { code, message } } for structured errors,
 * or { detail: "text" } for legacy errors.
 * Pass a `t` function to auto-translate known error codes.
 */
export function errorMessage(err, t) {
  const d = err?.response?.data?.detail;
  if (d && typeof d === "object" && d.code) {
    if (t) {
      const key = `err_${d.code}`;
      const translated = t(key);
      if (translated && translated !== key) return translated;
    }
    return d.message || d.code;
  }
  if (typeof d === "string") return d;
  return err?.message || "Unknown error";
}

export default api;
